import {
  ExportValidation,
  StartExportResponse,
  VeridionExport,
  ExportListPagination
} from '../../services/veridion-export.service';

export interface VeridionExportState {
  validation: {
    isLoading: boolean;
    result: ExportValidation | null;
    error: string | null;
  };
  startExport: {
    isLoading: boolean;
    result: StartExportResponse | null;
    error: string | null;
  };
  exports: {
    items: VeridionExport[];
    isLoading: boolean;
    error: string | null;
    pagination: ExportListPagination;
  };
  download: {
    downloadingIds: number[];
    error: string | null;
  };
}

export const initialVeridionExportState: VeridionExportState = {
  validation: {
    isLoading: false,
    result: null,
    error: null
  },
  startExport: {
    isLoading: false,
    result: null,
    error: null
  },
  exports: {
    items: [],
    isLoading: false,
    error: null,
    pagination: {
      total: 0,
      per_page: 15,
      current_page: 1,
      last_page: 1
    }
  },
  download: {
    downloadingIds: [],
    error: null
  }
};
